import { signal, computed, effect, effectScope } from 'alien-signals';
import { useSyncExternalStore, useCallback, useEffect, useMemo } from 'react';

// src/index.ts
function createSignal(initialValue) {
  return signal(initialValue);
}
function createComputed(fn) {
  return computed(fn);
}
function createEffect(fn) {
  return effect(fn);
}
function createSignalScope(callback) {
  return effectScope(callback);
}
function useSignal(signal) {
  const value = useSyncExternalStore(
    (callback) => createEffect(() => {
      signal();
      callback();
    }),
    () => signal(),
    () => signal()
  );
  const setValue = useCallback((val) => {
    if (typeof val === "function") {
      signal(val(signal()));
    } else {
      signal(val);
    }
  }, [signal]);
  return [value, setValue];
}
function useSignalValue(signal) {
  return useSyncExternalStore(
    (callback) => createEffect(() => {
      signal();
      callback();
    }),
    () => signal(),
    () => signal()
  );
}
function useSetSignal(signal) {
  return useCallback((val) => {
    if (typeof val === "function") {
      signal(val(signal()));
    } else {
      signal(val);
    }
  }, [signal]);
}
function useSignalEffect(fn) {
  useEffect(() => {
    let cleanup;
    const stop = createEffect(() => {
      if (cleanup) cleanup();
      cleanup = fn();
    });
    return () => {
      if (cleanup) cleanup();
      stop();
    };
  }, [fn]);
}
function useSignalScope(callback) {
  const stopScope = useMemo(() => createSignalScope(callback), [callback]);
  useEffect(() => () => stopScope(), [stopScope]);
  return stopScope;
}
function useComputed(getter) {
  const computed = useMemo(() => createComputed(getter), [getter]);
  return useSignalValue(computed);
}

export { createComputed, createEffect, createSignal, createSignalScope, useComputed, useSetSignal, useSignal, useSignalEffect, useSignalScope, useSignalValue };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map